function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import _ from 'lodash';
import errors from 'shared/core/fieldValidationErrorMessages';
import { yup } from 'shared/core/yup';
import { ORDER_TYPE_PICKUP, ORDER_TYPE_DELIVERY } from 'shared/constants';
function userTest(value) {
    return _userTest.apply(this, arguments);
}
function _userTest() {
    _userTest = _async_to_generator(function(value) {
        return _ts_generator(this, function(_state) {
            // for now lets just make sure it exists
            if (!value) {
                return [
                    2,
                    this.createError({
                        message: "We couldn't find a valid user for this userId"
                    })
                ];
            }
            return [
                2,
                true
            ];
        });
    });
    return _userTest.apply(this, arguments);
}
function photoId(param) {
    var requirePhotoIdForPickup = param.requirePhotoIdForPickup, requirePhotoIdForDelivery = param.requirePhotoIdForDelivery, orderType = param.orderType, isKioskOrder = param.isKioskOrder, userId = param.userId;
    var required = requirePhotoIdForPickup && orderType === ORDER_TYPE_PICKUP || requirePhotoIdForDelivery && orderType === ORDER_TYPE_DELIVERY;
    return {
        message: errors.photoId.missing,
        test: function test(value) {
            // Skip validation for kiosk orders with logged-in users
            if (isKioskOrder && userId) {
                return true;
            }
            if (required && _.isEmpty(value)) {
                return false;
            }
            return true;
        }
    };
}
export function getUserSchema(param) {
    var orderType = param.orderType, requirePhotoIdForDelivery = param.requirePhotoIdForDelivery, requirePhotoIdForPickup = param.requirePhotoIdForPickup, _param_makeProfileFieldsOptional = param.makeProfileFieldsOptional, makeProfileFieldsOptional = _param_makeProfileFieldsOptional === void 0 ? false : _param_makeProfileFieldsOptional, _param_isKioskOrder = param.isKioskOrder, isKioskOrder = _param_isKioskOrder === void 0 ? false : _param_isKioskOrder, _param_userId = param.userId, userId = _param_userId === void 0 ? null : _param_userId;
    return yup.object().nullable().required(errors.user.missing).shape({
        _id: yup.string().required(errors.user.invalid),
        services: yup.object().shape({
            password: yup.object().shape({
                bcrypt: yup.string()
            })
        }),
        emails: yup.array().required().of(yup.object().shape({
            address: yup.string().email(errors.email.invalid).required(errors.user.invalid)
        })),
        profile: yup.object().shape({
            birthday: makeProfileFieldsOptional ? yup.string().nullable() : yup.string().required(errors.birthday.missing),
            firstName: yup.string().test('len', errors.firstName.missingShort, function(v) {
                return _.trim(v).length;
            }).required(errors.firstName.missingShort),
            lastName: yup.string().test('len', errors.lastName.missingShort, function(v) {
                return _.trim(v).length;
            }).required(errors.lastName.missingShort),
            // medicalCard: null,
            phone: makeProfileFieldsOptional ? yup.string().phone(errors.phone.missing).nullable() : yup.string().phone(errors.phone.missing).required(errors.phone.missing),
            photoId: yup.string().nullable().test(photoId({
                requirePhotoIdForPickup: requirePhotoIdForPickup,
                requirePhotoIdForDelivery: requirePhotoIdForDelivery,
                orderType: orderType,
                isKioskOrder: isKioskOrder,
                userId: userId
            })),
            textNotifications: yup.boolean(),
            emailNotifications: yup.boolean()
        })
    }).test({
        test: userTest
    });
}
